import { IconReportMoney, IconUserBolt, IconVector } from "@tabler/icons-react";
import bg1 from '../assets/images/bg1.jpg'
import bg2 from '../assets/images/bg2.jpg'
import bg3 from '../assets/images/bg3.jpg'
import bg4 from '../assets/images/bg4.jpg'

export const UserRoles = [
  { id: 2, label: "User", value: "User" },
  { id: 1, label: "Admin", value: "Admin" }
]

export const RolejobColors: Record<string, string> = {
  manager: "blue",
  admin: "cyan",
  user: "brown",
};
export const avatarUrls = [
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-2.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-3.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-4.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-5.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-6.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-7.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-8.png',
  'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-9.png',
];

export const verticalMenus = [

  {
    id: 1,
    title: "Admin",
    src: IconUserBolt,
    menusLink: [
      { id: 2, name: "Manage Users", route: '/manageuser', active: false },
      { id: 1, name: "Manage Logs", route: '/managelogs', active: false },
    ]
  },
];
export const verticalMenusUsers = [
  {
    id: 1,
    title: "Inventory",
    route: '/inventory',
    src: IconVector,
  },
  {
    id: 2,
    title: "Sales",
    route: '/sales',
    src: IconReportMoney,
  },
];

export const themeColors = [
  {
    name: "blue-theme",
    color: "#0867FE",
    secondary_color: "#3985fe",
    territory_color: "#83b3fe",
    filter: `invert(60%) sepia(93%) saturate(668%) hue-rotate(188deg) brightness(102%) contrast(102%)`

  },
  {
    name: "green-theme",
    color: "#03C9d7",
    secondary_color: "#67dee7",
    territory_color: "#9ae9ef",
    filter: `invert(52%) sepia(48%) saturate(2818%) hue-rotate(147deg) brightness(107%) contrast(98%)`

  },
  {
    name: "purple-theme",
    color: "#7352ff",
    secondary_color: "#8f74ff",
    territory_color: "#b9a8ff",
    filter: `invert(58%) sepia(99%) saturate(5633%) hue-rotate(236deg) brightness(97%) contrast(107%)`
  },
  {
    name: "red-theme",
    color: "#ff5C8e",
    secondary_color: "#ff7ca4",
    territory_color: "#ffadc6",
    filter: `invert(49%) sepia(88%) saturate(1623%) hue-rotate(309deg) brightness(101%) contrast(101%)`
  },
  {
    name: "indigo-theme",
    color: "#2a3042",
    secondary_color: "#3f4454",
    territory_color: "#7f828d",
    filter: `invert(13%) sepia(6%) saturate(3863%) hue-rotate(188deg) brightness(100%) contrast(84%)`
  },
  {
    name: "orange-theme",
    color: "#041e42",
    secondary_color: "#041e42",
    territory_color: "#f0bd87",
    filter: ``
  },
  
];

export const sideBarBgImage = [
  {
    id: 1,
    src: bg1,
    name: "backgroundImage_1"
  },
  {
    id: 2,
    src: bg2,
    name: "backgroundImage_2"
  },
  {
    id: 3,
    src: bg3,
    name: "backgroundImage_3"
  },
  {
    id: 4,
    src: bg4,
    name: "backgroundImage_4"
  },
]